<template>
  <div>
    <spacer :y="6"/>
    <ul>
      <stack-item>
        <contents-box
          :title="user.school[0].billing_type.billing_type === 1 ? '登録QRコード' : '組織情報'"
          :icon="user.school[0].billing_type.billing_type === 1 ? '<i class=\'fa-regular fa-qrcode\'></i>' : '<i class=\'fa-solid fa-school\'></i>'">
          <loader-simple :flag="flag.loader">
            <ul v-if="school">
              <stack-item space="2">
                <contents-box type="inner">
                  <div :class="$style.school">
                    <div>
                      <div :class="$style.kana">{{ school.kana }}</div>
                      <div :class="$style.name">{{ school.name }}</div>
                    </div>
                  </div>

                  <ul :class="$style.detail">
                    <spacer :y="3"/>
                    <li v-if="user.school[0].billing_type.billing_type === 1">
                      <i :class="$style.icon" class="fa-solid fa-qrcode"></i>
                      <p :class="$style.content"><a :href="`${baseURL}/signup/?school=${school.id}`" target="_blank">{{ baseURL }}/signup/?school={{ school.id }}</a></p>
                    </li>
                    <li v-if="user.school[0].billing_type.billing_type === 1">
                      <p :class="$style.content">
                        <img :src="`https://api.qrserver.com/v1/create-qr-code/?data=${baseURL}/signup?school=${school.id}&size=150x150`">
                      </p>
                    </li>
                    <!-- 契約情報グループ（指示書の該当図面）。QR 画像の直下に契約系の項目をまとめ、
                         見出しと上下の区切り線で明示的に1グループとして見せる。
                         ここの住所/電話番号は「契約担当者」固有の連絡先であり、下の管理者情報エリアに
                         出す組織自身の住所/電話（schools.address / schools.tel）とは意味の異なる別項目。
                         「管理者と同一」ON では契約担当者が組織側の値へフォールバックして同値になるため、
                         ON の間は住所/電話番号の行を出さない（分岐の実体は contractPersonRow.sameAsAdmin）。
                         人物行の中身（氏名/カナ/メール/所属・職階）は「管理者と同一」バッジが同値である旨を
                         明示するので ON でも出す＝独立した項目行と人物行で扱いを分ける。 -->
                    <li :class="$style.group_heading">契約情報</li>
                    <!-- 契約プランは契約の属性なので契約情報グループの先頭（見出しの直下）に置く
                         （組織自身の属性を並べる下のグループとは所属が違う）。
                         契約名（contracts.name）は顧客指示で非表示化した（列とデータは残置）。 -->
                    <li>
                      <i :class="$style.icon" class="fa-solid fa-file-user"></i>
                      <p :class="$style.field_label">契約プラン</p>
                      <p :class="$style.content">
                        {{ helper.master.labels.schools.billing_type[school.billing_type.billing_type] }}
                        <span :class="$style.bold" v-if="school.billing_type.billing_type === 1 && school.contract && school.contract.cycle">{{ school.contract.cycle === 1 ? '月次' : '年次' }}</span>
                      </p>
                    </li>
                    <li v-if="school.contract && school.contract.contract_date">
                      <i :class="$style.icon" class="fa-regular fa-calendar"></i>
                      <p :class="$style.field_label">契約年月日</p>
                      <p :class="$style.content">{{ contractDateLabel }}</p>
                    </li>
                    <!-- 契約主体の名称は schools.corporate_name（法人名）を読む。schools.name は
                         「画面に出す名前」＝サイト表示名なので、契約情報には出さない。
                         同タブ上部の組織名・カナは看板表示なので name / kana のままでよい。 -->
                    <li>
                      <i :class="$style.icon" class="fa-solid fa-building"></i>
                      <p :class="$style.field_label">法人名</p>
                      <p :class="$style.content">{{ school.corporate_name }}</p>
                    </li>
                    <!-- 住所・電話番号は契約担当者固有の値のときだけ出す。「管理者と同一」ON では
                         contractPersonRow が組織側（= 管理者に紐づく schools.address / schools.tel）へ
                         フォールバックして下の管理者情報エリアと同値になるため、行ごと描画しない。
                         値を null にする方式を採らないのは、住所行が v-else で「登録なし」を出す作りで、
                         重複が消える代わりに「登録なし」が並んでしまうため（電話行・メール span は v-else
                         を持たないが、条件の書き方を揃えて分岐を1軸に見せる）。 -->
                    <li v-if="!contractPersonRow.sameAsAdmin">
                      <i :class="$style.icon" class="fa-regular fa-house"></i>
                      <p :class="$style.field_label">住所</p>
                      <p v-if="contractPersonRow.address" :class="$style.content">
                        <span v-if="contractPersonRow.address.zip" :class="$style.zip">〒{{ contractPersonRow.address.zip }}</span>
                        <span>{{ contractPersonRow.address.pref }}</span>
                        <span>{{ contractPersonRow.address.city }}</span>
                        <span v-if="contractPersonRow.address.address">{{ contractPersonRow.address.address }}</span>
                        <!-- 番地と建物名の間は半角スペースで分ける。テンプレートに素の空白を書くと
                             コンパイラ（whitespace: 'condense'）が要素先頭・末尾の空白のみのテキストノードを
                             削除して消えるため、補間の中に空白を含める。 -->
                        <span v-if="contractPersonRow.address.building">{{ ' ' + contractPersonRow.address.building }}</span>
                      </p>
                      <p v-else :class="$style.content">登録なし</p>
                    </li>
                    <li v-if="!contractPersonRow.sameAsAdmin && contractPersonRow.tel">
                      <i :class="$style.icon" class="fa-solid fa-phone"></i>
                      <p :class="$style.field_label">電話番号</p>
                      <p :class="$style.content">{{ contractPersonRow.tel }}</p>
                    </li>
                    <!-- 契約担当者は管理者/副管理者と同じバッジ形式を保つ（図面の [担当者] 表記に対応）。
                         並びは指示書 P6 の「氏名（メールアドレス）（部署/職階）」に揃える。
                         グループの終端線は次の「管理者情報」見出しの上罫線が兼ねる（下罫線を重ねると二重線になる）。 -->
                    <li :class="$style.flexstart">
                      <label-box
                        :class="$style.label"
                        label="契約担当者"
                        size="xs" color="orange" />
                      <ul :class="$style.content_list">
                        <li>
                          <span>{{ contractPersonRow.name || '未登録' }}</span>
                          <span v-if="contractPersonRow.kana" :class="$style.affiliation">（{{ contractPersonRow.kana }}）</span>
                          <!-- 氏名・カナ・メール・所属/職階は「管理者と同一」ON でも出す。隣の
                               「管理者と同一」バッジが同値である旨を明示するため、管理者行と同じ値でも
                               説明のつかない重複にならない（独立した項目行として並ぶ住所・電話番号とは扱いが違う）。 -->
                          <span v-if="contractPersonRow.email">（<a :href="`mailto:${contractPersonRow.email}`">{{ contractPersonRow.email }}</a>）</span>
                          <span v-if="contractPersonRow.sameAsAdmin" :class="$style.same_as_admin">管理者と同一</span>
                          <!-- 部署/職階は氏名の下に 1 項目 1 行で縦積み（事務局サイト SchoolList と同体裁）。
                               content_list の li は :not(:last-child) に '/' セパレータが付くため、
                               ここは li ではなく div で足すこと。
                               契約担当者は組織種類によらず固定ラベルで役割を持たないため、管理者行が使う
                               schoolAdminDisplay ではなく contractPersonAttrs（固定 defs）で描画する。 -->
                          <div
                            v-for="f in contractPersonAttrs(contractPersonRow)"
                            :key="f.label"
                            :class="$style.attr_line">
                            {{ f.label }}: {{ f.value }}
                          </div>
                        </li>
                      </ul>
                    </li>

                    <!-- 管理者情報グループ。契約情報と同じ「見出し＋項目名つきの行」の作りに揃える。
                         同じ画面に住所/電話が2組（契約担当者の連絡先と組織自身の連絡先）並ぶため、
                         アイコンだけでは行を識別できず、見出しで所属グループ・項目名で行を特定させる。 -->
                    <li :class="$style.group_heading">管理者情報</li>
                    <!-- 学校タイプは「個人向け」が値 0 で、truthy 判定だと行ごと消えるため null/undefined だけを除く。
                         非学校（インターン/企業）は is_company で判定して従来どおり行を出さない。新規登録では school_type=6 が
                         入るが既存には 4 の組織もあり、school_type の値では判定しない。 -->
                    <li v-if="school.school_type != null && !school.is_company">
                      <i :class="$style.icon" class="fa-solid fa-graduation-cap"></i>
                      <p :class="$style.field_label">学校タイプ</p>
                      <p :class="$style.content">{{ helper.master.labels.schools.school_type[school.school_type] }}</p>
                    </li>
                    <!-- 管理者情報エリアの連絡先は組織自身の値（schools.address / schools.tel）。
                         住所・電話番号は組織登録の必須項目なので、未登録でも行を残して「登録なし」を出し
                         欠落自体を可視化する。
                         上の契約情報グループに出る住所/電話は契約担当者の連絡先で、こことは別項目。
                         組織のメールアドレス（schools.email）は顧客依頼で撤去した。実データは 2 組織にしか
                         無く、いずれも主管理者／契約担当者の欄に同じアドレスが出ている重複表示だったため
                         （列とデータは残置）。 -->
                    <li>
                      <i :class="$style.icon" class="fa-regular fa-house"></i>
                      <p :class="$style.field_label">住所</p>
                      <p v-if="school.address" :class="$style.content">
                        <span v-if="school.address.zip" :class="$style.zip">〒{{ school.address.zip }}</span>
                        <span>{{ school.address.pref }}</span>
                        <span>{{ school.address.city }}</span>
                        <span v-if="school.address.address">{{ school.address.address }}</span>
                        <!-- 空白の書き方の理由は上の契約情報側の住所行のコメントを参照。 -->
                        <span v-if="school.address.building">{{ ' ' + school.address.building }}</span>
                      </p>
                      <p v-else :class="$style.content">登録なし</p>
                    </li>
                    <li>
                      <i :class="$style.icon" class="fa-solid fa-phone"></i>
                      <p :class="$style.field_label">電話番号</p>
                      <p :class="$style.content">{{ school.tel || '登録なし' }}</p>
                    </li>
                    <li :class="$style.flexstart">
                      <label-box
                        :class="$style.label"
                        label="管理者"
                        size="xs" color="orange" />
                      <ul
                        :class="$style.content_list"
                        v-if="school.mainUser">
                        <li>
                          <span>{{ school.mainUser[0].username }}</span>
                          <span v-if="school.mainUser[0].kana" :class="$style.affiliation">（{{ school.mainUser[0].kana }}）</span>
                          <span>（<a :href="`mailto:${school.mainUser[0].email}`">{{ school.mainUser[0].email }}</a>）</span>
                          <div
                            v-for="f in schoolAdminDisplay(mainAdminAttributes)"
                            :key="f.label"
                            :class="$style.attr_line">
                            {{ f.label }}: {{ f.value }}
                          </div>
                        </li>
                      </ul>
                    </li>
                    <li :class="$style.flexstart">
                      <label-box
                        :class="$style.label"
                        label="副管理者"
                        size="xs" color="orange" />
                      <ul :class="[$style.content_list, $style.subuser_list]">
                        <li v-for="subuser in mergedSubUsers" :key="`${subuser._source}-${subuser.id}`">
                          <span>{{ subuser.username }}</span>
                          <span v-if="subuser.kana" :class="$style.affiliation">（{{ subuser.kana }}）</span>
                          <span v-if="subuser.email">（<a :href="`mailto:${subuser.email}`">{{ subuser.email }}</a>）</span>
                          <span v-if="!isSubSchoolAdmin" :class="$style.status_badge_wrap">
                            <span :class="[$style.status_badge, $style[`status_${subuser.loginStatus}`]]">{{ loginStatusLabel(subuser.loginStatus) }}</span>
                            <span :class="$style.status_hint">
                              <i class="fa-regular fa-circle-question" :class="$style.status_hint_icon"></i>
                              <span :class="$style.status_tooltip">{{ loginStatusDetail(subuser.loginStatus) }}</span>
                            </span>
                          </span>
                          <div
                            v-for="f in schoolAdminDisplay(subuser)"
                            :key="f.label"
                            :class="$style.attr_line">
                            {{ f.label }}: {{ f.value }}
                          </div>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </contents-box>
              </stack-item>
            </ul>
          </loader-simple>
        </contents-box>

        <spacer
          :y="3"
          v-if="school.billing_type.billing_type === 2" />
        <contents-box
          title="利用者登録状況"
          icon="<i class='fa-solid fa-user-plus'></i>"
          v-if="school.billing_type.billing_type === 2">
          <loader-simple :flag="flag.countTemporaries">
            <p :class="$style.temporary_info">
              <span :class="$style.temporary_info_label">本登録</span>
              <span :class="$style.temporary_info_num">
                {{ registCount }}<span :class="$style.temporary_info_num_mini"> / {{ registCount + temporaryCount }}</span>
              </span>名
            </p>
            <p :class="$style.temporary_info">
              <span :class="$style.temporary_info_label">未登録</span>
              <span :class="$style.temporary_info_num">
                {{ temporaryCount }}<span :class="$style.temporary_info_num_mini"> / {{ registCount + temporaryCount }}</span>
              </span>名
            </p>
          </loader-simple>
        </contents-box>
        <spacer :y="5" />

        <contents-box title="オンライン・バーチャル健康相談" icon="<i class='fa-solid fa-coins'></i>">
          <div :class="$style.label_wrap">
            <p :class="$style.label">保有クレジット: <span>{{ schoolCredit || 0 }}</span></p>
            <p :class="$style.detailed_explanation" v-if="school.billing_type.billing_type === 1">※医師相談=２クレジット使用</p>
            <div :class="$style.flex_history" v-if="this.school.billing_type.billing_type === 2">
              <p>クレジット編集履歴</p>
              <div>
                <loader-simple :flag="flag.school_count.includes(this.school.id)" :mini="true" :isDisableMinHight="true">
                  <div v-if="!(flag.school_count.includes(this.school.id))">
                    <i
                      v-if="!opensusCreditIds"
                      :class="$style.count"
                      class="fa-solid fa-plus"
                      v-on:click="changeOpensusCreditIds()"/>
                    <i
                      v-if="opensusCreditIds"
                      :class="$style.count"
                      class="fa-solid fa-minus"
                      v-on:click="changeOpensusCreditIds()"/>
                  </div>
                </loader-simple>
              </div>
            </div>
            <spacer :x="2" />

            <div :class="$style.flex_history" v-if="this.school.billing_type.billing_type === 2 && opensusCreditIds">
              <div :class="$style.max_flex" v-if="!susCreditHistorys.length">変更履歴はありません</div>
              <div v-else :class="$style.categories">
                <dl :class="$style.category">
                  <dt v-for="count in susCreditHistorysLabals" :key="count.label">
                    {{ count.label }}
                  </dt>
                </dl>
                <dl :class="$style.category"
                  v-for="history in susCreditHistorys" :key="history">
                  <dd
                    v-for="count in susCreditHistorysLabals"
                    :key="count.label">
                    <p v-if="count.name === 'date'">{{ history.date }}</p>
                    <p v-if="count.name === 'editor'">{{ history.editor }}</p>
                    <p v-if="count.name === 'target'">{{ history.target }}</p>
                    <p v-if="count.name === 'content'">{{ history.content }}</p>
                    <p v-if="count.name === 'counselor_type'">{{ history.counselor_type }}</p>
                    <p v-if="count.name === 'credit'">{{ history.credit }}</p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>

          <div
            v-if="school.billing_type.billing_type === 2
              && schoolCredit > 0">
            <spacer :y="4" />

            <div :class="$style.label_wrap">
              <p :class="$style.label">利用者別にオンライン健康相談の回数を付与</p>
              <p :class="$style.assistance">※医師相談の回数付与は<b>2クレジット</b>、心理士相談は<b>1クレジット</b>を消費します。</p>
              <p :class="$style.assistance">チェックした利用者にまとめてクレジットを付与します。</p>
            </div>
            <spacer :y="3" />
            <limit-counter
              :flag="flag"
              :school="school"
              :sustainableAddCreditHistory="true"
              :creditTarget="creditTargets"
              :isSchoolAdmin="true"
              @updateTarget="regetTargets"
              @updateSchool="updateSchool" />
            <spacer :y="3" />

            <div :class="$style.sortBox">
              <div :class="$style.top">
                <div :class="$style.search_wrap">
                  <word-search-form
                    :class="$style.search_word"
                    v-on:sendValue="receiveValue"
                    :placeholder="isCompany ? '利用者を検索' : '生徒を検索'" />
                  <div :class="$style.search_button">
                    <basic-btn
                      tag="button"
                      @click="getUsers(), flag.exeSearch=true">検索</basic-btn>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isCompany" :class="$style.birth">
                <spacer :y="2" />
                <dl>
                  <dt><i class="fa-solid fa-graduation-cap"></i>学年</dt>
                  <dd>
                    <div>
                      <select
                        :class="$style.select_box"
                        v-model="schoolYear"
                        name="schoolYear"
                        id="schoolYear"
                        @change="updateSchoolYear">
                        <option :value="null">選択なし</option>
                        <option
                          v-for="n of setSchoolYear()"
                          :key="n"
                          :value="n">{{ n }}</option>
                      </select>
                    </div>
                  </dd>
                </dl>
              </div>
              <spacer :y="2" />
              <div v-if="flag.exeSearch">
                <div>
                  <spacer :y="2"/>
                  <input type="checkbox" id="bulkChek" v-model="bulkChek">
                  <label for="bulkChek">一括チェック</label>
                  <spacer :y="2"/>
                </div>
                <stack-item v-for="row in creditTargets" :key="row.id">
                  <div :class="$style.check_user">
                    <input
                      :class="$style.user_check_box"
                      type="checkbox"
                      :id="`checked_${row.id}`"
                      :value="row.id"
                      v-model="creditTargetIds"
                      @change="updateTargets" />
                    <label
                      :for="`checked_${row.id}`"
                      :class="$style.check_user_box">
                      <user-box
                        :showId="true"
                        :showCocomoniBtn="true"
                        :ownUser="user"
                        v-if="users.length"
                        :user="row"
                        saveTab="students"
                        :bg="userBoxColor(row)">
                      </user-box>
                    </label>
                  </div>
                </stack-item>
                <stack-item v-for="row in filteredUsers" :key="row.id">
                  <div :class="$style.check_user">
                    <input
                      :class="$style.user_check_box"
                      type="checkbox"
                      :id="`stillCheck_${row.id}`"
                      :value="row.id"
                      v-model="creditTargetIds"
                      @change="updateTargets" />
                    <label
                      :for="`stillCheck_${row.id}`"
                      :class="$style.check_user_box">
                      <user-box
                        :showId="true"
                        :showCocomoniBtn="true"
                        :ownUser="user"
                        v-if="users.length"
                        :user="row"
                        saveTab="students"
                        :bg="userBoxColor(row)">
                      </user-box>
                    </label>
                  </div>
                </stack-item>
              </div>
          </div>
        </contents-box>

        <spacer :y="3" v-if="school.billing_type.billing_type === 1" />
        <contents-box
          v-if="school.billing_type.billing_type === 1"
          title="テキスト健康相談"
          icon="<i class='fa-sharp fa-light fa-abacus'></i>">
          <div :class="$style.label_wrap">
            <p :class="$style.label">利用可能回数: <span>{{ schoolTextCount || 0 }}</span></p>
          </div>
        </contents-box>
<!--
        <spacer :y="5" />
        <unregist-school-year
          :school="user.school[0]"/>
-->
      </stack-item>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LabelBox from '@/views/components/LabelBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import UserBox from '@/views/components/UserBox.vue';
import WordSearchForm from '@/views/components/WordSearchForm.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import LimitCounter from '@/views/components/LimitCounter4BillingAccount.vue';
// import UnregistSchoolYear from '@/views/components/UnregistSchoolYear.vue';
import moment from 'moment';
import cf from '@/mixins/commonFunctions.js';
import saf from '@/mixins/schoolAdminFunctions';

export default {
  name: 'qr',
  mixins: [cf, saf],
  props: ['school'],
  components: {
    LabelBox,
    Spacer,
    ContentsBox,
    StackItem,
    UserBox,
    WordSearchForm,
    BasicBtn,
    LoaderSimple,
    LimitCounter,
    // UnregistSchoolYear,
  },
  data() {
    return {
      flag: {
        loader: true,
        disabled: true,
        countTemporaries: true,
        initial: true,
        exeSearch: false,
        school_count: [],
      },
      users: [],
      allUsers: [],
      temporaryCount: 0,
      registCount: 0,
      creditTargetId: 0,
      creditTargetIds: [],
      schoolYear: null, // 学年検索機能追加のため
      creditTargets: [],
      opensusCreditIds: false,
      susCreditHistorys: [],
      bulkChek: false,
      registSituation: {
        completion: [],
        temporary: [],
      },
      susCreditHistorysLabals: [ // アカウント課金、クレジット付与の履歴、初期にやる利用可能回数一括調整とは別
        {
          label: '編集日',
          name: 'date',
        },
        {
          label: '編集者',
          name: 'editor',
        },
        {
          label: '対象',
          name: 'target',
        },
        {
          label: '種別',
          name: 'counselor_type',
        },
        {
          label: '内容',
          name: 'content',
        },
        {
          label: 'クレジット数',
          name: 'credit',
        },
      ],
    };
  },
  created() {
    if (this.school) {
      if (this.school.billing_type.billing_type === 1) this.flag.loader = false;
      else if (this.school.billing_type.billing_type === 2) {
        this.getTempcount(this.school);
        this.getUsers();
        this.getSustainableAddCredit();
      }
    }
  },
  watch: {
    school() {
      this.flag.loader = false;
    },
    bulkChek() {
      if (this.bulkChek) {
        this.filteredUsers.forEach((elem) => {
          this.creditTargets.push(elem);
          this.creditTargetIds.push(elem.id);
        });
      } else {
        this.creditTargets = [];
        this.creditTargetIds = [];
      }
      this.updateTargets();
    },
  },
  computed: {
    ...mapState(['user', 'helper']),
    baseURL() {
      return `${location.protocol}//${location.host}`;
    },
    /** 閲覧者が副管理者(12)か。副管理者には同校管理者のログインステータスバッジを見せない(#4) */
    isSubSchoolAdmin() {
      return this.user && Number(this.user.account_type) === 12;
    },
    /**
     * 学校の保持クレジット
     *   該当校の課金タイプが
     *     1 => 従量課金: school.count
     *     2 => アカウント課金: school.mainUser[0].count.credit
     */
    schoolCredit() {
      const billingType = this.school.billing_type.billing_type;
      let credit = 0;
      if (billingType === 1) credit = this.school.count;
      else if (billingType === 2) credit = this.school.mainUser[0].count.credit;
      return credit;
    },
    /**
     * 従量課金、テキスト健康相談利用可能回数
     */
    schoolTextCount() {
      const billingType = this.school.billing_type.billing_type;
      let count = 0;
      if (billingType === 1) count = this.school.textCount;
      return count;
    },
    /**
     * アカウント課金
     * 学校に所属する利用者
     */
    schoolCustomers() {
      const result = [];
      this.school.users.forEach((user) => {
        if (user.account_type < 11) result.push(user);
      });
      return result;
    },
    filteredUsers() {
      const targetIds = this.creditTargets.map((item) => item.id);
      return this.users.filter((user) => !targetIds.includes(user.id));
    },
    /**
     * 副管理者一覧（レガシー subUsers + users(account_type=12) を統合）
     * #3185 で副管理者の格納先が分割されたため、両ソースをマージして表示する。
     */
    mergedSubUsers() {
      const rows = [];
      if (!this.school) return rows;
      const now = moment();
      if (Array.isArray(this.school.subUser)) {
        this.school.subUser.forEach((s) => {
          if (s.flag !== 999 && Number(s.migrated) !== 1) {
            rows.push({
              // subUsers 由来は「ログイン有効化リンク未送信（通知メールのみ運用）」→ not_sent と同表示
              // subUsers レコードには所属/職階/役割が無いため null（School.vue の mergedSubUsers と同マッピング）
              id: s.id, username: s.username, kana: s.kana || null, email: s.email, department: null, position: null, role: null, loginStatus: 'not_sent', _source: 'subUsers',
            });
          }
        });
      }
      if (Array.isArray(this.school.schoolAdmins)) {
        this.school.schoolAdmins.forEach((a) => {
          const u = a.user;
          if (u && Number(u.account_type) === 12 && Number(u.flag) === 1) {
            // ログイン状態の派生（School.vue / UpdateSchool.vue の mergedSubUsers と同ロジック）:
            //   available: password 設定済み / pending: リンク送信済・期限内 / expired: 期限切れ / not_sent: 未送信
            const hasPassword = !!u.has_password;
            let loginStatus;
            if (hasPassword) loginStatus = 'available';
            else if (u.expiry && moment(u.expiry).isAfter(now)) loginStatus = 'pending';
            else if (u.expiry) loginStatus = 'expired';
            else loginStatus = 'not_sent';
            rows.push({
              // 所属/職階/役割は schoolAdmins ピボット列（事務局サイト SchoolList の subAdminUsers と同マッピング）。
              // role を落とすと、役割に実値を持つ副管理者で事務局サイトと表示が食い違う（表示列はサイト種別で決まる）
              id: u.id, username: u.username, kana: u.kana || null, email: u.email, department: a.department || null, position: a.position || null, role: a.role || null, loginStatus, _source: 'users',
            });
          }
        });
      }
      return rows;
    },
    /**
     * 契約年月日の表示文字列。
     * contract_date は datetime 列で ISO-UTC 形式で届くため、非JST端末での日付ずれを避けて
     * JST(+9)固定で整形する（frontend.md「日時取扱い」の壁時計表示 utcOffset(540) 固定に準拠）。
     */
    contractDateLabel() {
      if (!this.school || !this.school.contract || !this.school.contract.contract_date) return '';
      return moment(this.school.contract.contract_date).utcOffset(540).format('YYYY年MM月DD日');
    },
    /**
     * 主管理者(account_type=11)の所属/職階/役割。schoolAdmins ピボット行から拾う。
     * 管理者行の属性表示と、契約担当者の「管理者と同一」代替表示で共用する。
     */
    mainAdminAttributes() {
      let department = null;
      let position = null;
      let role = null;
      if (this.school && Array.isArray(this.school.schoolAdmins)) {
        const mainAdmin = this.school.schoolAdmins.find((a) => a.user && Number(a.user.account_type) === 11);
        if (mainAdmin) {
          department = mainAdmin.department || null;
          position = mainAdmin.position || null;
          role = mainAdmin.role || null;
        }
      }
      return { department, position, role };
    },
    /**
     * 契約担当者の表示行。ON/OFF は schools.contract_same_as_admin で判定する。
     *   - contract_same_as_admin!=0（既定・列未到達の undefined も ON 扱い）: 主管理者(11)の情報を
     *       代替表示（sameAsAdmin=true）。部署/職階は schoolAdmins ピボット(account_type=11)から拾う
     *       （管理者の役割は契約担当者行には出さないため role は持ち回らない）。
     *       連絡先・住所も管理者に紐づく側（mainUser.email / schools.tel / addresses(model_type=2)）を出す。
     *   - contract_same_as_admin=0: contractPerson の実値を表示（行が無ければ name null → 未登録表示）。
     * address は schools.address（addresses 行）と同じ形（zip/pref/city/address/building）で返し、
     * テンプレ側がフォールバック先を意識せず同一の描画で済むようにする。
     */
    contractPersonRow() {
      const sameAsAdmin = !this.school || Number(this.school.contract_same_as_admin) !== 0;
      if (sameAsAdmin) {
        const main = this.school && Array.isArray(this.school.mainUser) ? this.school.mainUser[0] : null;
        const { department, position } = this.mainAdminAttributes;
        return {
          name: main ? main.username : null,
          kana: main ? main.kana : null,
          email: (main && main.email) || null,
          department,
          position,
          tel: (this.school && this.school.tel) || null,
          address: (this.school && this.school.address) || null,
          sameAsAdmin: true,
        };
      }
      const cp = this.school ? this.school.contractPerson : null;
      // 住所 5 列がすべて空なら null を返し、テンプレの「登録なし」表示へ倒す
      const hasAddress = !!cp && [cp.zip, cp.pref, cp.city, cp.address, cp.building].some(Boolean);
      return {
        name: (cp && cp.name) || null,
        kana: (cp && cp.kana) || null,
        email: (cp && cp.email) || null,
        department: (cp && cp.department) || null,
        position: (cp && cp.position) || null,
        tel: (cp && cp.tel) || null,
        address: hasAddress ? {
          zip: cp.zip, pref: cp.pref, city: cp.city, address: cp.address, building: cp.building,
        } : null,
        sameAsAdmin: false,
      };
    },
  },
  methods: {
    /** schoolAdmins ピボット行（または merged 副管理者行）から表示用 {label, value} 配列を
     *  生成（空値は除外）。表示列は mixin schoolAdminFieldDefs でサイト種別に応じて絞る。
     *  契約担当者行は対象外 — 種別非依存の固定ラベルで役割を持たないため mixin contractPersonAttrs を使う。
     *  管理タブは単一組織のみ扱うため、事務局サイト SchoolList.vue の同名メソッドから row 引数を落とし
     *  this.school を直接見る版（表示体裁は SchoolList と同一に揃える）。 */
    schoolAdminDisplay(source) {
      if (!source || !this.school) return [];
      return this.schoolAdminFieldDefs(this.school.is_company, this.school.school_type)
        .map((f) => ({ label: f.label, value: source[f.name] }))
        .filter((x) => x.value && String(x.value).trim() !== '');
    },
    /** ログインステータスのラベル文言（loginStatus → 表示文字列） */
    loginStatusLabel(status) {
      return ({
        available: 'ログイン可能',
        pending: '本人によるパスワード設定待ち',
        expired: 'リンク期限切れ・要再送',
        not_sent: 'リンク未送信',
      })[status] || '';
    },
    /** ログインステータスのホバー説明文言 */
    loginStatusDetail(status) {
      return ({
        available: 'パスワード設定済みで、本人がログインできる状態です。',
        pending: 'ログイン有効化リンクを送信済みです。本人がパスワードを設定するとログイン可能になります。',
        expired: '送信したログイン有効化リンクの有効期限が切れています。リンクを再送してください。',
        not_sent: 'ログイン有効化リンクが未送信です。リンクを送信すると本人がパスワードを設定できます。',
      })[status] || '';
    },
    // masterのデータから該当する学校の学年を取得
    setSchoolYear() {
      if (this.user.school) {
        const school = this.user.school[0];
        const yearIndex = Object.keys(this.helper.master.schoolYear).findIndex((elem) => this.helper.master.schoolYear[elem].label === school.school_type);
        const schoolYear = this.helper.master.schoolYear[yearIndex].value;
        return schoolYear + 2;
      }
    },
    /**
     * アカウント課金
     * 回数追加・削除の有効無効
     * 対象ユーザオブジェクトの仕込み
     */
    updateTargets() {
      // const disabled = !this.creditTargetIds || !Number(this.creditTargetIds);
      // 配列を想定して書き換え
      const disabled = !this.creditTargetIds.length || !this.creditTargetIds.every((id) => typeof id === 'number');
      this.flag.disabled = disabled;

      if (!disabled) {
        this.creditTargets = this.users.filter((user) => this.creditTargetIds.includes(user.id));
      } else {
        this.creditTargets = [];
      }
    },

    // 子コンポーネントから受け取ったデータを格納
    receiveValue(data) {
      const userIdRegex = new RegExp(/^[0-9０-９]{4}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{1,}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{4}$/);
      if (userIdRegex.test(data.value)) {
        const userId = data.value.split(/[-|ー|−|―|‐|-|ｰ]/);
        this.keyword = String(Number(this.toHalfNumber(userId[2]))); // user.id指定
        this.targetColumn = ['id', 'old_id', 'tel']; // 0120-12-3456のtelも引っかかる
      } else {
        this.keyword = data.value;
        this.targetColumn = ['username', 'kana', 'id'];
      }
    },

    /** アカウント課金モデルの場合にはユーザーのリストを取得 */
    async getUsers(payload) {
      let newUsers = [];
      let params = null;
      if (payload && payload.fromChild === true) {
        params = {
          id: this.school.id,
          ids: this.creditTargetIds,
        };
      } else {
        params = {
          id: this.school.id,
          targetColumn: this.keyword && this.keyword !== '' ? this.targetColumn : null,
          keyword: this.keyword && this.keyword !== '' ? this.keyword : null,
          school_year: this.schoolYear,
          noTemporary: true,
        };
      }
      await this.axios({
        method: 'GET',
        url: '/v1/school/get/subject',
        params,
      })
        .then((response) => {
          const res = response.data.subject;
          newUsers = res.users.filter((user) => user.account_type < 11);
          if (this.flag.initial && res.billing_type.billing_type === 2) {
            this.allUsers = res.users.filter((user) => user.account_type < 11);
            this.countTemporaryUser(); // 組織の契約が従量課金であれば仮登録の利用者をカウント
            this.flag.initial = false;
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          // 検索をかけた時に、this.usersから値がなくなってしまうと、this.creditTargetsにも保持できないために追加
          const creditTargetIds = this.creditTargets.map((item) => item.id);
          const newUserIds = newUsers.map((user) => user.id);
          const idsToAdd = creditTargetIds.filter((id) => !newUserIds.includes(id));
          const usersToAdd = this.creditTargets.filter((user) => idsToAdd.includes(user.id));
          newUsers = [...newUsers, ...usersToAdd];
          this.users = newUsers;
          if (newUsers.some((user) => user.billing_type && user.billing_type.billing_type === 2)) {
            this.countTemporaryUser(); // 組織の契約が従量課金であれば仮登録の利用者をカウント
          }
          if (payload && payload.fromChild === true) {
            this.updateTargets();
          }
          this.flag.loader = false;
        });
    },

    // アカウント課金、利用可能回数更新後の回数取得用
    async regetTargets() {
      const params = { // チェックのついている利用者の情報を取得
        ids: [],
      };

      this.creditTargetIds.forEach((id) => {
        params.ids.push(id);
      });

      this.axios({
        method: 'GET',
        url: '/v1/user/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.users.data;
          this.creditTargets = [];
          res.forEach((user) => {
            this.creditTargets.push(user);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    // アカウント課金の仮登録、本登録の人数を返却
    async getTempcount(school) {
      // 従量課金タイプだったら即返却
      if (school.billing_type.billing_type === 1) return true;

      const params = { school_id: school.id };
      this.axios({
        method: 'GET',
        url: '/v1/user/get/tempCount',
        params,
      })
        .then((response) => {
          const res = response.data.result;
          this.temporaryCount = res.temporary;
          this.registCount = res.regist;
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    // 学年で絞り込み
    updateSchoolYear(e) {
      this.schoolYear = Number(e.target.value);
      if (!Number(e.target.value)) this.schoolYear = null;
    },

    /** アカウント課金のみ */
    countTemporaryUser() {
      this.allUsers.forEach((user) => {
        if (user.temporary) this.registSituation.temporary.push(user);
        else this.registSituation.completion.push(user);
      });
      this.flag.countTemporaries = false;
    },

    /** userBox背景色指定用 */
    userBoxColor(user) {
      let color;
      if (user.flag !== 1) {
        color = 'gray';
      } else if (user.temporary) {
        color = 'silver';
      } else {
        color = 'white';
      }
      return color;
    },

    /** limitCounterでカウント付与後、学校情報更新 */
    updateSchool() {
      this.$emit('updateSchool');
    },

    // クレジット変動履歴の表表示フラグ切り替え
    async changeOpensusCreditIds() {
      this.opensusCreditIds = !this.opensusCreditIds;
    },

    /**
     * アカウント課金タイプのオンラインクレジット付与履歴を取得
     * 表示するのは
     * 事務局→学校クレジット
     * 事務局→利用者クレジット
     * 学校→利用者クレジット
    */
    async getSustainableAddCredit() {
      if (this.school.billing_type.billing_type === 1) return true; // 学校タイプが従量課金だったら即返却

      const params = {
        school_id: this.school.id,
        isUsers: 1,
        isSchool: 1,
        isTargetUser: 1,
      };

      this.axios({
        methods: 'GET',
        url: '/v1/sustainableAddCredit/get/list',
        params,
      })
        .then((response) => {
          const res = response.data.data.data;
          res.forEach((data) => {
            const insertData = {
              date: moment(data.created_at).format('YYYY年MM月DD日'),
              editor: data.regist_user.account_type === 31 ? '事務局' : data.regist_user.username,
              target: data.target_user_id ? data.target_user.username : data.school.name,
              content: `${data.credit}クレジット${data.is_add ? '追加' : '削除'}`,
              credit: `${data.credit}クレジット`,
              is_add: data.is_add,
              counselor_type: 'なし',
            };
            if (data.counselor_type) { // カウンセラータイプNULLになるのは事務局→学校のパターンのみ
              insertData.counselor_type = data.counselor_type === 22 ? '心理士' : '医師';
              const count = data.counselor_type === 22 ? data.credit : data.credit / 2; // 回数表記用
              insertData.content = `${count}回${data.is_add ? '追加' : '削除'}`;
            }
            if (data.target_user // 事務局から利用者に直接クレジットを付与したものは表示しない
              && data.regist_user.account_type === 31
              && data.target_user.account_type <= 3) {
              return true;
            }
            this.susCreditHistorys.push(insertData);
          });
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error.message);
        });
    },
  },
};
</script>

<style lang="scss" module>
.flex_history {
  display: flex;
  align-items: center;
  .categories {
    $mgn: 40px;
    $gry: #ccc;
    $bdr: 1px solid $gry;
    $pd: .5em;
    width: 100%;
    .category {
      font-size: .8em;
      padding: $mgn/5 0;
      border-bottom: $bdr;
      display: flex;
      margin-block-start: 0;
      margin-block-end: 0;
      // width: 90%;
      &:first-child {
        border-top: $bdr;
      }
      > dt, dd {
        padding: 0 $pd;
        margin-inline-start: 0;
      }
    > dt {
        width: 45%;
      }
      > dd {
        flex: 1;
      }
      .link {
        margin-left: auto;
        padding-left: 1em;
      }
    }
  }
}
.count {
  margin-left: 1em;
  cursor: pointer;
}

.kana {
  font-size: 12px;
}
.name {
  font-size: 20px;
  font-weight: bold;
}
.school {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icons {
  display: flex;
  align-items: center;
}
.plus {
  cursor: pointer;
  font-size: 20px;
  color: var(--gray-side);
  &:not(:first-child) {
    margin-left: 20px;
  }
}
.detail {
  li {
    display: flex;
    align-items: center;
    @include sm-view {
      display: block;
    }
    &.flexstart {
      align-items: flex-start;
    }
    // グループ（契約情報 / 管理者情報）の小見出し。上の区切り線とセットでグループの開始を示す。
    // 前グループの終端線も兼ねるため、行側に下罫線を持たせない（重ねると二重線になる）
    &.group_heading {
      display: block;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid var(--gray-main);
      font-weight: bold;
    }
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    // FontAwesome は字形ごとに実幅が違う（graduation-cap 1.25em / house 1.125em / phone 1em 等）。
    // 幅を固定しないとアイコンの差がそのまま後続の項目名・値の開始位置に伝播し、行ごとに
    // 値の x 位置がずれる。fa-fw と同じ 1.25em で固定して契約情報・管理者情報の値を縦に揃える。
    .icon {
      display: inline-block;
      width: 1.25em;
      text-align: center;
      font-size: 20px;
      color: var(--orange-main);
      margin-right: 10px;
    }
    // 属性行の項目名（契約情報・管理者情報の両グループ共通）。人物行（管理者/副管理者/契約担当者）は
    // 項目名でなくバッジ(.label)で種別を示すので、こちらは持たない
    .field_label {
      width: 96px;
      white-space: nowrap;
      margin-right: 10px;
      font-size: 13px;
      color: var(--gray-side);
    }
    .label {
      // 「契約担当者」(5文字・font-size 12px + padding) が 60px では収まらないため広げた。
      // 管理者/副管理者/契約担当者の 3 ラベル共通幅。
      width: 72px;
      white-space: nowrap;
      margin-right: 10px;
    }
    .content {
      flex: 1;
      // 郵便番号と住所文字列の間を 1 マス空ける。テキスト側の半角スペースだと字形・フォント依存で
      // 幅が変わり、行によって間隔が揃わないため margin で 1rem に固定する。
      .zip {
        margin-right: 1rem;
      }
      &_list {
        flex: 1;
        display: flex;
        li {
          // 人物行の li は .detail li の display:flex を継ぐため内側は flex 行になる。
          // 属性行(.attr_line)を flex-basis:100% で次行へ送るには wrap が要る（SchoolList と同構成）。
          flex-wrap: wrap;
          &:not(:last-child) {
            margin-bottom: 0;
            &::after {
              content: '/';
              padding: 0 10px;
            }
          }
        }
      }
    }
    // 副管理者一覧は 1 名ごとに改行表示（#3185 で複数副管理者が可能になったため）
    .subuser_list {
      display: block;
      li {
        flex-wrap: wrap;
        &:not(:last-child) {
          margin-bottom: 4px;
          &::after {
            content: none;
            padding: 0;
          }
        }
      }
    }
  }
  a {
    color: var(--black);
    text-decoration: underline;
    transition: all .4s;
    &:hover {
      opacity: .6;
    }
  }
}
.bold {
  font-weight: bold;
}
// 人物行のオプション情報（所属/役職/職階）は氏名の下に 1 項目 1 行で縦積みする。
// 事務局サイト（SchoolList）と同じ体裁。
// 親の li は .detail li の display:flex を継ぐため、flex-basis:100% で次行へ強制的に折り返す
// （SchoolList の .full_width と同じ役割。親側の flex-wrap:wrap とセットで効く）。
.attr_line {
  flex-basis: 100%;
  font-size: 12px;
  color: var(--gray-side);
}
// 人物行（管理者/副管理者/契約担当者）の氏名カナの補足表示。3 行で表記を揃える。
// 所属/職階/役割は .attr_line（氏名の下に縦積み）へ分離済み。
.affiliation {
  font-size: 12px;
  color: var(--gray-side);
  margin-left: 6px;
}
// 契約担当者が主管理者と同一である旨のバッジ
.same_as_admin {
  font-size: 11px;
  margin-left: 8px;
  padding: 1px 6px;
  border-radius: 4px;
  background-color: var(--gray-sub);
  color: var(--black);
}
.center {
  text-align: center;
}

.label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  span {
    font-size: 28px;
    margin-left: 5px;
  }
  &_flex {
    display: flex;
    align-items: center;
    dt {
      font-weight: bold;
    }
    dd {
      margin-left: .8em;
    }
  }
}

.assistance {
  font-size: 14px;
}

.select {
  padding: 13px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  border-radius: 8px;
  &:disabled {
    color: black;
    background-color: transparent;
    &:-webkit-autofill {
      box-shadow: 0 0 0 100px white inset;
    }
  }

  &_box {
    width: 100px;
    padding: 13px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    border-radius: 8px;
    appearance: none;

    &_wrap {
      display: flex;

      li {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
}
.check_user {
  display: flex;
  &_box {
    flex: 1;
  }
}

.detailed_explanation{
  font-size: .7em;
}

.temporary_info {
  font-weight: bold;

  &_label {
    margin-left: 2em;
    display: inline-block;
    width: 95px;
  }

  &_num {
    font-size: 1.5em;
    &_mini {
      font-size: 15px;
    }
  }
}
.search_wrap {
  display: flex;
  .search_word {
    flex: 8.5;
  }
  .search_button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1.5;
  }
}
.sortBox {
  > * {
    align-items: center;
  }
  @include sm-view {
    > * {
      display: block;
      .search_wrap {
        width: 100%;
        .search_word {
          margin: 0;
        }
      }
    }
  }
}
.user_check {
  display: flex;
  &_box {
    margin-right: 1em;
  }
  &_user_box {
    flex-grow: 1;
  }
}

.birth {
  flex: 1;
  dl {
    display: flex;
    align-items: center;
    margin: 0;
  }
  dt {
    width: 7em;
    i {
      margin-right: .5em;
    }
  }
  dd {
    flex: 1;
    display: flex;
    margin-left: 1em;
    > div {
      display: flex;
      align-items: center;
      &:nth-child(2) {
        margin-left: 1em;
        &:before {
          content: "~";
          margin-right: 1em;
        }
      }
    }
  }
  @include sm-view {
    dl {
      display: block;
      margin: 1em 0 .4em;
    }
    dt {
      font-size: 14px;
    }
    dd {
      margin: 0;
    }
  }
}

// 副管理者のログインステータスバッジ（School.vue / UpdateSchool.vue / SchoolList.vue と同デザイン）
.status_badge_wrap {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  vertical-align: middle;
}
.status_badge {
  display: inline-block;
  font-size: .75em;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
}
// ホバーで詳細を表示する旨を `?` アイコンで明示（PJ 慣行: fa-circle-question + cursor:help）
.status_hint {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  cursor: help;
  &:hover .status_tooltip {
    visibility: visible;
    opacity: 1;
  }
}
.status_hint_icon {
  font-size: 13px;
  color: #888;
}
.status_tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 240px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  color: #fff;
  background-color: #333;
  border-radius: 6px;
  white-space: normal;
  transition: opacity 0.2s;
  z-index: 10;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #333;
  }
}
.status_available {
  color: #fff;
  background-color: var(--green-main);
}
.status_pending {
  color: #fff;
  background-color: var(--blue-main);
}
.status_expired {
  color: #fff;
  background-color: var(--orange-main);
}
.status_not_sent {
  color: var(--black);
  background-color: var(--gray-sub);
}
</style>
